import React from 'react';
import { NavLink } from 'react-router-dom';
import { useFitStore } from '../../store/useFitStore';
import { getNavItems, NavIcon, leadsDueCount } from './nav';

const TopNav: React.FC = () => {
  const { user, leads } = useFitStore();
  if (!user) return null;

  const navItems = getNavItems(user.role);
  const leadsDue = leadsDueCount(leads);

  return (
    <nav className="top-nav">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/coach' || item.path === '/client'}
          className={({ isActive }) => `top-nav-link ${isActive ? 'active' : ''}`}
        >
          <span className="relative">
            <NavIcon name={item.icon} className="w-[15px] h-[15px]" />
            {item.path === '/coach/leads' && leadsDue > 0 && (
              <span className="absolute -top-1 -right-1.5 min-w-[14px] h-[14px] px-1 rounded-full bg-white text-fit-ink text-[9px] font-bold leading-[14px] text-center">
                {leadsDue}
              </span>
            )}
          </span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default TopNav;
